import { render, staticRenderFns } from "./settings-element.vue?vue&type=template&id=57a50140&scoped=true"
import script from "./settings-element.vue?vue&type=script&lang=js"
export * from "./settings-element.vue?vue&type=script&lang=js"
import style0 from "./settings-element.vue?vue&type=style&index=0&id=57a50140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a50140",
  null
  
)

export default component.exports